import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '../../../../../../../node_modules/@angular/forms';
import {MatChipInputEvent, MatSnackBar} from '../../../../../../../node_modules/@angular/material';
import {COMMA, ENTER} from '../../../../../../../node_modules/@angular/cdk/keycodes';
import {ConsumerService} from '../../../../recursos/servicio/consumer.service';
import {Emisor} from '../recursos/modelo/emisor';
import {BillingConfiguration} from '../recursos/modelo/emisor-configuration';
import {TipoDocumento} from '../recursos/modelo/tipo-documento.enum';

@Component({
    selector: 'cmp-conf-series',
    templateUrl: './view/cmp-conf-series.component.html',
    styleUrls: ['./css/cmp-conf-series.component.scss']
})
export class CmpConfSeriesComponent implements OnInit {

    form: FormGroup;
    vdl_facturaItems: FormControl;
    vdl_boletaItems: FormControl;
    vdl_NCItems: FormControl;
    vdl_NDItems: FormControl;
    vdl_PercepcionItems: FormControl;
    vdl_RetencionItems: FormControl;
    vdl_GRItems: FormControl;
    vdl_GTItems: FormControl;

    seriesFacturaReenvio = [];
    seriesBoletaReenvio = [];
    seriesNCReenvio = [];
    seriesNDReenvio = [];
    seriesPercepcionReenvio = [];
    seriesRetencionReenvio = [];
    seriesGRReenvio = [];
    seriesGTReenvio = [];

    separatorKeysCodes = [ENTER, COMMA];
    removable: boolean = true;
    addOnBlur: boolean = true;
    emisorConfig: BillingConfiguration = new BillingConfiguration();

    @Input() emisor: Emisor;

    constructor(private fb: FormBuilder, private snackBar: MatSnackBar, private consumerService: ConsumerService) {
        this.createFormControls();
        this.createForm();
    }

    ngOnInit(): void {
        if (this.emisor) {
            if (this.emisor.billingList.length > 0) {
                this.cargarSeries(this.emisor.billingList);
            }
        } else {
            this.emisor = new Emisor();
        }
    }

    createFormControls() {
        this.vdl_facturaItems = new FormControl({value: ""});
        this.vdl_boletaItems = new FormControl({value: ""});
        this.vdl_NCItems = new FormControl({value: ""});
        this.vdl_NDItems = new FormControl({value: ""});
        this.vdl_PercepcionItems = new FormControl({value: ""});
        this.vdl_RetencionItems = new FormControl({value: ""});
        this.vdl_GRItems = new FormControl({value: ""});
        this.vdl_GTItems = new FormControl({value: ""});
    }

    createForm() {
        this.form = this.fb.group({
            chipFacturaList: this.vdl_facturaItems,
            "chipBoletaList": this.vdl_boletaItems,
            "chipNCList": this.vdl_NCItems,
            "chipNDList": this.vdl_NDItems,
            "chipPercepcionList": this.vdl_PercepcionItems,
            "chipRetencionList": this.vdl_RetencionItems,
            "chipGRList": this.vdl_GRItems,
            "chipGTList": this.vdl_GTItems
        });
    }

    add(event: MatChipInputEvent, documento: string): void {
        let input = event.input;
        let value = event.value;
        if (value != '') {
            switch (documento) {
                case 'factura': {
                    let regExp = new RegExp('[F]{1}[A-Z0-9]{3}');
                    if ((value || '').trim() && this.validarSerie(value, documento) && regExp.test(value)) {
                        this.seriesFacturaReenvio.push(value.trim());
                        this.actualizarEmisor(TipoDocumento.INVOICE, value);
                        this.vdl_facturaItems.setErrors({validarFactura: false, longitudFactura: false, pattern: false})
                    } else {
                        !regExp.test(value) ? this.vdl_facturaItems.setErrors({pattern: true}) : value.length === 4 ? this.vdl_facturaItems.setErrors({validarFactura: true}) : value.length > 0 ? this.vdl_facturaItems.setErrors({longitudFactura: true}) : '';
                    }
                    break;
                }
                case 'boleta': {
                    let regExp = new RegExp('[B]{1}[A-Z0-9]{3}');
                    if ((value || '').trim() && this.validarSerie(value, documento) && regExp.test(value)) {
                        this.seriesBoletaReenvio.push(value.trim());
                        this.actualizarEmisor(TipoDocumento.TICKET, value);
                        this.vdl_boletaItems.setErrors({validarBoleta: false, longitudBoleta: false, pattern: false})
                    } else {
                        !regExp.test(value) && value.length > 0 ? this.vdl_boletaItems.setErrors({pattern: true}) : value.length === 4 ? this.vdl_boletaItems.setErrors({validarBoleta: true}) : value.length > 0 ? this.vdl_boletaItems.setErrors({longitudBoleta: true}) : '';
                    }
                    break;
                }
                case 'NC': {
                    let regExp = new RegExp('[BFS]{1}[A-Z0-9]{3}');
                    if ((value || '').trim() && this.validarSerie(value, documento) && regExp.test(value)) {
                        this.seriesNCReenvio.push(value.trim());
                        this.actualizarEmisor(TipoDocumento.CREDIT_NOTE, value);
                        this.vdl_NCItems.setErrors({validarNC: false, longitudNC: false, pattern: false})
                    } else {
                        !regExp.test(value) && value.length > 0 ? this.vdl_NCItems.setErrors({pattern: true}) : value.length === 4 ? this.vdl_NCItems.setErrors({validarNC: true}) : value.length > 0 ? this.vdl_NCItems.setErrors({longitudNC: true}) : '';
                    }
                    break;
                }
                case 'ND': {
                    let regExp = new RegExp('[BFS]{1}[A-Z0-9]{3}');
                    if ((value || '').trim() && this.validarSerie(value, documento) && regExp.test(value)) {
                        this.seriesNDReenvio.push(value.trim());
                        this.actualizarEmisor(TipoDocumento.DEBIT_NOTE, value);
                        this.vdl_NDItems.setErrors({validarND: false, longitudND: false, pattern: false})
                    } else {
                        !regExp.test(value) && value.length > 0 ? this.vdl_NDItems.setErrors({pattern: true}) : value.length === 4 ? this.vdl_NDItems.setErrors({validarND: true}) : value.length > 0 ? this.vdl_NDItems.setErrors({longitudND: true}) : '';
                    }
                    break;
                }
                case 'Percepcion': {
                    let regExp = new RegExp('[P]{1}[A-Z0-9]{3}');
                    if ((value || '').trim() && this.validarSerie(value, documento) && regExp.test(value)) {
                        this.seriesPercepcionReenvio.push(value.trim());
                        this.actualizarEmisor(TipoDocumento.PERCEPTION, value);
                        this.vdl_PercepcionItems.setErrors({
                            validarPercepcion: false,
                            longitudPercepcion: false,
                            pattern: false
                        })
                    } else {
                        !regExp.test(value) && value.length > 0 ? this.vdl_PercepcionItems.setErrors({pattern: true}) : value.length === 4 ? this.vdl_PercepcionItems.setErrors({validarPercepcion: true}) : value.length > 0 ? this.vdl_PercepcionItems.setErrors({longitudPercepcion: true}) : '';
                    }
                    break;
                }
                case 'Retencion': {
                    let regExp = new RegExp('[R]{1}[A-Z0-9]{3}');
                    if ((value || '').trim() && this.validarSerie(value, documento) && regExp.test(value)) {
                        this.seriesRetencionReenvio.push(value.trim());
                        this.actualizarEmisor(TipoDocumento.RETENTION, value);
                        this.vdl_RetencionItems.setErrors({
                            validarRetencion: false,
                            longitudRetencion: false,
                            pattern: false
                        })
                    } else {
                        !regExp.test(value) && value.length > 0 ? this.vdl_RetencionItems.setErrors({pattern: true}) : value.length === 4 ? this.vdl_RetencionItems.setErrors({validarRetencion: true}) : value.length > 0 ? this.vdl_RetencionItems.setErrors({longitudRetencion: true}) : '';
                    }
                    break;
                }
                case 'GR': {
                    let regExp = new RegExp('[T]{1}[A-Z0-9]{3}');
                    if ((value || '').trim() && this.validarSerie(value, documento) && regExp.test(value)) {
                        this.seriesGRReenvio.push(value.trim());
                        this.actualizarEmisor(TipoDocumento.DESPATCH_ADVICE, value);
                        this.vdl_GRItems.setErrors({validarGR: false, longitudGR: false, pattern: false})
                    } else {
                        !regExp.test(value) && value.length > 0 ? this.vdl_GRItems.setErrors({pattern: true}) : value.length === 4 ? this.vdl_GRItems.setErrors({validarGR: true}) : value.length > 0 ? this.vdl_GRItems.setErrors({longitudGR: true}) : '';
                    }
                    break;
                }
                case 'GT': {
                    let regExp = new RegExp('[V]{1}[A-Z0-9]{3}');
                    if ((value || '').trim() && this.validarSerie(value, documento) && regExp.test(value)) {
                        this.seriesGTReenvio.push(value.trim());
                        this.actualizarEmisor(TipoDocumento.DESPATCH_TRANSPORT, value);
                        this.vdl_GRItems.setErrors({validarGT: false, longitudGT: false, pattern: false})
                    } else {
                        !regExp.test(value) && value.length > 0 ? this.vdl_GTItems.setErrors({pattern: true}) : value.length === 4 ? this.vdl_GTItems.setErrors({validarGT: true}) : value.length > 0 ? this.vdl_GRItems.setErrors({longitudGT: true}) : '';
                    }
                    break;
                }
                default:
                    break;
            }
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    validarSerie(valor, documento) {
        let repetida = 0;
        //Validar si existe en otro documento repetida la serie
        this.seriesFacturaReenvio.filter(e => e === valor).length === 1 ? repetida++ : repetida;
        this.seriesBoletaReenvio.filter(e => e === valor).length === 1 ? repetida++ : repetida;
        this.seriesNCReenvio.filter(e => e === valor).length === 1 ? repetida++ : repetida;
        this.seriesNDReenvio.filter(e => e === valor).length === 1 ? repetida++ : repetida;
        this.seriesPercepcionReenvio.filter(e => e === valor).length === 1 ? repetida++ : repetida;
        this.seriesRetencionReenvio.filter(e => e === valor).length === 1 ? repetida++ : repetida;
        this.seriesGRReenvio.filter(e => e === valor).length === 1 ? repetida++ : repetida;
        this.seriesGTReenvio.filter(e => e === valor).length > 1 ? repetida++ : repetida;
        //Validar si existe dos veces la misma serie en un documento
        this.seriesFacturaReenvio.filter(e => e === valor).length > 1 ? repetida++ : repetida;
        this.seriesBoletaReenvio.filter(e => e === valor).length > 1 ? repetida++ : repetida;
        this.seriesNCReenvio.filter(e => e === valor).length > 1 ? repetida++ : repetida;
        this.seriesNDReenvio.filter(e => e === valor).length > 1 ? repetida++ : repetida;
        this.seriesPercepcionReenvio.filter(e => e === valor).length > 1 ? repetida++ : repetida;
        this.seriesRetencionReenvio.filter(e => e === valor).length > 1 ? repetida++ : repetida;
        this.seriesGRReenvio.filter(e => e === valor).length > 1 ? repetida++ : repetida;
        this.seriesGTReenvio.filter(e => e === valor).length > 1 ? repetida++ : repetida;
        if (valor.length === 4 && repetida === 0) //&& errorPattern(valor, documento))
            return true;
        return false;
    }

    remove(serie: any, documento): void {
        switch (documento) {
            case 'factura': {
                let index = this.seriesFacturaReenvio.indexOf(serie);

                if (!this.errorRemove(TipoDocumento.INVOICE, serie)) {
                    this.seriesFacturaReenvio.splice(index, 1);
                    this.actualizarEmisor(TipoDocumento.INVOICE, serie, true);

                    this.vdl_facturaItems.setErrors({removeFactura: false})
                } else {
                    this.vdl_facturaItems.setErrors({removeFactura: true})
                }
                break;
            }
            case 'boleta': {
                let index = this.seriesBoletaReenvio.indexOf(serie);

                if (!this.errorRemove(TipoDocumento.TICKET, serie)) {
                    this.seriesBoletaReenvio.splice(index, 1);
                    this.actualizarEmisor(TipoDocumento.TICKET, serie, true);
                    this.vdl_boletaItems.setErrors({removeBoleta: false})
                } else {
                    this.vdl_boletaItems.setErrors({removeBoleta: true})
                }
                break;
            }
            case 'NC': {
                let index = this.seriesNCReenvio.indexOf(serie);

                if (!this.errorRemove(TipoDocumento.CREDIT_NOTE, serie)) {
                    this.seriesNCReenvio.splice(index, 1);
                    this.actualizarEmisor(TipoDocumento.CREDIT_NOTE, serie, true);
                    this.vdl_NCItems.setErrors({removeNC: false})
                } else {
                    this.vdl_NCItems.setErrors({removeNC: true})
                }
                break;
            }
            case 'ND': {
                let index = this.seriesNDReenvio.indexOf(serie);

                if (!this.errorRemove(TipoDocumento.DEBIT_NOTE, serie)) {
                    this.seriesNDReenvio.splice(index, 1);
                    this.actualizarEmisor(TipoDocumento.DEBIT_NOTE, serie, true);
                    this.vdl_NDItems.setErrors({removeND: false})
                } else {
                    this.vdl_NDItems.setErrors({removeND: true})
                }
                break;
            }
            case 'Percepcion': {
                let index = this.seriesPercepcionReenvio.indexOf(serie);

                if (!this.errorRemove(TipoDocumento.PERCEPTION, serie)) {
                    this.seriesPercepcionReenvio.splice(index, 1);
                    this.actualizarEmisor(TipoDocumento.PERCEPTION, serie, true);
                    this.vdl_PercepcionItems.setErrors({removePercepcion: false})
                } else {
                    this.vdl_PercepcionItems.setErrors({removePercepcion: true})
                }
                break;
            }
            case 'Retencion': {
                let index = this.seriesRetencionReenvio.indexOf(serie);

                if (!this.errorRemove(TipoDocumento.RETENTION, serie)) {
                    this.seriesRetencionReenvio.splice(index, 1);
                    this.actualizarEmisor(TipoDocumento.RETENTION, serie, true);
                    this.vdl_RetencionItems.setErrors({removeRetencion: false})
                } else {
                    this.vdl_RetencionItems.setErrors({removeRetencion: true})
                }
                break;
            }
            case 'GR': {
                let index = this.seriesGRReenvio.indexOf(serie);

                if (!this.errorRemove(TipoDocumento.DESPATCH_ADVICE, serie)) {
                    this.seriesGRReenvio.splice(index, 1);
                    this.actualizarEmisor(TipoDocumento.DESPATCH_ADVICE, serie, true);
                    this.vdl_GRItems.setErrors({removeGR: false})
                } else {
                    this.vdl_GRItems.setErrors({removeGR: true})
                }
                break;
            }
            case 'GT': {
                let index = this.seriesGTReenvio.indexOf(serie);

                if (!this.errorRemove(TipoDocumento.DESPATCH_TRANSPORT, serie)) {
                    this.seriesGTReenvio.splice(index, 1);
                    this.actualizarEmisor(TipoDocumento.DESPATCH_TRANSPORT, serie, true);
                    this.vdl_GTItems.setErrors({removeGT: false})
                } else {
                    this.vdl_GTItems.setErrors({removeGT: true})
                }
                break;
            }
            default:
                break;
        }

    }

    actualizarEmisor(documento: TipoDocumento, serialNumber, eliminar?) {
        this.emisorConfig = this.emisor.billingList.find(x => (x.documentType == documento && x.serialNumber == serialNumber));
        !this.emisorConfig ? this.emisorConfig = new BillingConfiguration() : this.emisorConfig;
        let index = this.emisor.billingList.indexOf(this.emisorConfig);
        this.emisorConfig.serialNumber = eliminar ? null : serialNumber;
        if (index < 0) {
            this.emisorConfig.documentType = documento;
            this.emisorConfig.customer.id = this.emisor.id;
            this.emisor.billingList.push(this.emisorConfig)
        } else {
            this.emisor.billingList[index] = this.emisorConfig;
        }
    }

    errorRemove(documento: TipoDocumento, serie: string) {
        if (this.emisor.billingList.length > 0) {
            this.emisorConfig = this.emisor.billingList.find(x => x.documentType == documento && x.serialNumber == serie);
        }
        if (this.emisorConfig.serialNumber.indexOf(serie) >= 0 && this.emisorConfig.consecutive > 0) {
            return true;
        }
        return false;
    }

    cargarSeries(billingList: BillingConfiguration[]) {
        billingList.forEach((billing) =>{
            if (billing.serialNumber) {
                switch (billing.documentType) {
                    case TipoDocumento.INVOICE:
                        this.seriesFacturaReenvio.push(billing.serialNumber);
                        break;
                    case TipoDocumento.TICKET:
                        this.seriesBoletaReenvio.push(billing.serialNumber);
                        break;
                    case TipoDocumento.CREDIT_NOTE:
                        this.seriesNCReenvio.push(billing.serialNumber);
                        break;
                    case TipoDocumento.DEBIT_NOTE:
                        this.seriesNDReenvio.push(billing.serialNumber);
                        break;
                    case TipoDocumento.PERCEPTION:
                        this.seriesPercepcionReenvio.push(billing.serialNumber);
                        break;
                    case TipoDocumento.RETENTION:
                        this.seriesRetencionReenvio.push(billing.serialNumber);
                        break;
                    case TipoDocumento.DESPATCH_ADVICE:
                        this.seriesGRReenvio.push(billing.serialNumber);
                        break;
                    case TipoDocumento.DESPATCH_TRANSPORT:
                        this.seriesGTReenvio.push(billing.serialNumber);
                        break;
                    default: {
                        console.log('NO SE CONSIGUIO GRUPO');
                    }
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-conf-series/cmp-conf-series.component.ts